var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative", "z-index": "999" } },
    [
      _c("header", [
        _vm.processing
          ? _c("div", { staticClass: "loading" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        !_vm.user && _vm.showPublicHeader
          ? _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row d-flex align-items-center mob-head" },
                [
                  !_vm.showHeader
                    ? _c("div", { staticClass: "col-lg-3 col-md-3 col-3" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.user
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-9 col-md-9 col-sm-9 col-8 text-right mob-right-sec"
                        },
                        [
                          _vm.$route.name !== "family-details"
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "login-btn",
                                  attrs: { to: "/login" }
                                },
                                [_vm._v("Login")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn red-btn",
                              attrs: {
                                href: "https://b1g1.com/family/",
                                target: "_blank"
                              }
                            },
                            [_vm._v("LEARN MORE")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showHeader
          ? _c(
              "div",
              {
                staticClass: "container",
                staticStyle: { position: "relative" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "row d-flex align-items-center cust-family-head"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-5 head-logo-blue-1" },
                      [
                        _c("RouterLink", { attrs: { to: "/" } }, [
                          _c("img", {
                            staticClass: "d-logo",
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              alt: "alt",
                              src: "/static/front/images/b1g1-logo-black.svg",
                              height: "66.45px",
                              width: "174px"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "m-logo",
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              alt: "alt",
                              src:
                                "/static/front/images/menu-images/b1g1-logo.svg"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 col-5 head-logo-blue-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "mobile-menu-list" },
                          [
                            _vm.user.role_id == 14
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "toggle",
                                    class: _vm.isDrawerOpen ? "change" : "",
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _c("div", { staticClass: "bar1" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "bar2" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "bar3" })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "businessLogo",
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/b1g1-logo.svg",
                                    alt: "alt"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "personalLogo",
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/b1g1-logo.svg",
                                    alt: "alt"
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-deasktop-custom" }, [
                          _c(
                            "div",
                            { staticClass: "menu-box-links" },
                            [
                              _c("a", { attrs: { href: "#giving-moments" } }, [
                                _vm._v("GIVE NOW")
                              ]),
                              _vm._v(" "),
                              _vm.user.role_id == 14
                                ? _c(
                                    "a",
                                    { attrs: { href: "/view-all-projects" } },
                                    [_vm._v("Projects")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("RouterLink", { attrs: { to: "/invite" } }, [
                                _vm._v("SHARE THE JOY")
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.user && _vm.showRoutes
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-4 d-flex align-items-center justify-content-end"
                          },
                          [
                            _vm.user.role_id == 14
                              ? _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "desktop-main-menu custom-menu-mobile",
                                    class: [
                                      _vm.isDrawerOpen ? "active" : "",
                                      (_vm.user.account === "user" &&
                                        _vm.isMobile) ||
                                      _vm.isIpad
                                        ? "p-user-sec-mobile"
                                        : ""
                                    ]
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "profile-mobile-menu" },
                                      [
                                        _vm.user.account !== "company"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "notification-wrapper"
                                              },
                                              [
                                                _c("span", [
                                                  _c("img", {
                                                    staticClass: "upload-img",
                                                    attrs: {
                                                      id: "profile-image",
                                                      src: _vm.family_logo
                                                        ? _vm.server +
                                                          "//uploads/family_logo/thumb/" +
                                                          _vm.family_logo
                                                            .split("/")
                                                            .pop()
                                                        : "/static/images/family-dashbord/bee.png",
                                                      alt:
                                                        "can-we-change-this-family"
                                                    },
                                                    on: {
                                                      error: function($event) {
                                                        return _vm.onFamilyImageLoadFailure(
                                                          $event,
                                                          "profile-image"
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .family_account_name
                                                  ? _c(
                                                      "h4",
                                                      {
                                                        staticStyle: {
                                                          width: "155px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.user
                                                              .user_business
                                                              .family_account_name
                                                              .length > 25
                                                              ? _vm.user.user_business.family_account_name.substr(
                                                                  0,
                                                                  25
                                                                ) + "..."
                                                              : _vm.user
                                                                  .user_business
                                                                  .family_account_name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.user.role_id == 14
                                      ? _c(
                                          "div",
                                          { staticClass: "menu-box-links" },
                                          [
                                            _c("a", { attrs: { href: "/" } }, [
                                              _vm._v("Home")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/view-all-projects"
                                                }
                                              },
                                              [_vm._v("Projects")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              { attrs: { href: "/invite" } },
                                              [_vm._v("SHARE THE JOY")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "noti" }, [
                              _c(
                                "aside",
                                {
                                  staticClass: "notifation",
                                  staticStyle: { margin: "0 0 0" },
                                  attrs: { id: "myDiv2" }
                                },
                                [
                                  _c("div", { staticClass: "home-iocn" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "/" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              x: "0px",
                                              y: "0px",
                                              width: "100",
                                              height: "100",
                                              viewBox: "0 0 32 32"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M 16 2.59375 L 15.28125 3.28125 L 2.28125 16.28125 L 3.71875 17.71875 L 5 16.4375 L 5 28 L 14 28 L 14 18 L 18 18 L 18 28 L 27 28 L 27 16.4375 L 28.28125 17.71875 L 29.71875 16.28125 L 16.71875 3.28125 Z M 16 5.4375 L 25 14.4375 L 25 26 L 20 26 L 20 16 L 12 16 L 12 26 L 7 26 L 7 14.4375 Z"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.cntNotification
                                      ? _c(
                                          "em",
                                          {
                                            attrs: { id: "notificationnumber" }
                                          },
                                          [_vm._v(_vm._s(_vm.cntNotification))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/static/front/images/menu-images/cart.svg",
                                        alt: ""
                                      },
                                      on: { click: _vm.closeNoti }
                                    })
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.user
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      _vm.user.account === "company"
                                        ? "user-sec"
                                        : "user-sec p-user-sec"
                                  },
                                  [
                                    _vm.user.account !== "company"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "notification-wrapper"
                                          },
                                          [
                                            _c("span", [
                                              _c("img", {
                                                staticClass: "upload-img",
                                                attrs: {
                                                  id: "profile-image",
                                                  src: _vm.family_logo
                                                    ? _vm.server +
                                                      "/uploads/family_logo/thumb/" +
                                                      _vm.family_logo
                                                        .split("/")
                                                        .pop()
                                                    : "/static/images/family-dashbord/bee.png",
                                                  alt:
                                                    "can-we-change-this-family"
                                                },
                                                on: {
                                                  error: function($event) {
                                                    return _vm.onFamilyImageLoadFailure(
                                                      $event,
                                                      "profile-image"
                                                    )
                                                  }
                                                }
                                              })
                                            ]),
                                            _vm._v(" "),
                                            _vm.user.user_business
                                              .family_account_name
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticStyle: {
                                                      width: "155px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.user.user_business
                                                          .family_account_name
                                                          .length > 25
                                                          ? _vm.user.user_business.family_account_name.substr(
                                                              0,
                                                              25
                                                            ) + "..."
                                                          : _vm.user
                                                              .user_business
                                                              .family_account_name
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user.account === "company"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "notification-wrapper"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v("Business Account")
                                            ]),
                                            _vm._v(" "),
                                            _c("ul", [
                                              _vm.isAdminLogin
                                                ? _c("li", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.adminAccount()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/admin-account.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "Back to Admin Account"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.user_business.company_id
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "business.company.profile"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/company-profile.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            " Company Profile"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.user_business &&
                                              _vm.user.user_business.is_admin &&
                                              _vm.user.user_business
                                                .is_business === 0
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "billing-details"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/billing.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v("Billing")
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isDowngradeUser
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "impact-reminders"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/alarm-clock.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "Your Giving Reminders"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.id === _vm.compnayOwnerId
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "reset-password"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/check.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "Login & Password Setting"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.logout()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/log-out.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v("Log Out")
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.user.user_business.company_id
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "switch-to-personal"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Switch to Personal Account"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              { staticClass: "d-none" },
                                              [
                                                _vm.isAdminLogin
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.adminAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Back to Admin Account"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .company_id
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "javascript:void(0)"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccountProfile()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Personal Profile & Settings"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "impact.history"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Impact History"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.id ===
                                                _vm.compnayOwnerId
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "reset-password"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Login & Password Setting"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .company_id
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Switch to Personal Account"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      {
                                                        staticClass: "menu-ti"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Company\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "business.company.profile"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Company Profile"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "1"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "token-management"
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.clickRightMenuClose()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "impact.history"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Impact History"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "1"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "token-management"
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.clickRightMenuClose()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management\n                  "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "0"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "tooltip",
                                                                    rawName:
                                                                      "v-tooltip.top",
                                                                    value: {
                                                                      content:
                                                                        "Upgrade to access",
                                                                      class:
                                                                        "normal-tooltip"
                                                                    },
                                                                    expression:
                                                                      "{ content: 'Upgrade to access', class: 'normal-tooltip' }",
                                                                    modifiers: {
                                                                      top: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "header-menu-disable"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "team-accounts-management"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Team Accounts Management\n                  "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "billing-details"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Billing")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("li", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.logout()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-sign-out-alt"
                                                      }),
                                                      _vm._v("Log Out")
                                                    ]
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user.account !== "company"
                                      ? _c("div", [
                                          !_vm.user.user_business
                                            .family_account_name
                                            ? _c("h4", [
                                                _vm._v("Your Family Account")
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.totalImpact && _vm.totalImpact > 0
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("numberFormat")(
                                                      _vm.totalImpact
                                                    )
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.totalImpact == 1
                                                        ? "impact to date"
                                                        : "impacts to date"
                                                    )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("ul", [
                                            _vm.isAdminLogin
                                              ? _c("li", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.adminAccount()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/static/front/images/drop-down-icon/admin-account.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "Back to Admin Account"
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "family-profile"
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickRightMenuClose()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/company-profile.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v("Profile Setting")
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.user && _vm.user.role_id === 14
                                              ? _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "family-details",
                                                            params: {
                                                              id: _vm.user.id
                                                            }
                                                          }
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickRightMenuClose()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/profile.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "Your Family Profile Page"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isDowngradeUser
                                              ? _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "billing-tokens"
                                                          }
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickRightMenuClose()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/billing.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.isMobile
                                                              ? "Manage Token and Billing"
                                                              : "Manage Billing"
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isDowngradeUser &&
                                            !_vm.isMobile
                                              ? _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "token-management"
                                                          }
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickRightMenuClose()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/token.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v("Manage Tokens")
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isDowngradeUser
                                              ? _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "impact-reminders"
                                                          }
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickRightMenuClose()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/alarm-clock.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "Your Giving Reminders"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "business.personal.reset-password"
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickRightMenuClose()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/check.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "Password and Account Info"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.logout()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        "/static/front/images/drop-down-icon/log-out.svg",
                                                      alt: ""
                                                    }
                                                  }),
                                                  _vm._v("Log Out")
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.user.user_business &&
                                            _vm.user.user_business.company_id &&
                                            parseInt(
                                              _vm.user.user_business.is_admin
                                            )
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "switch-to-personal"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.companyAccount()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Switch to Business Account"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._m(3)
                                  ]
                                )
                              : _c("div", { staticClass: "user-sec" }, [
                                  _c("span", [_vm._v("G")]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v("Guest "),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "white",
                                          "font-size": "18px"
                                        },
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            return _vm.logout()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-sign-out-alt"
                                        })
                                      ]
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dot-cion-menu",
                                on: { click: _vm.toggleRightMenu }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/static/front/images/drop-down-icon/menu-dots-icon.svg",
                                    alt: "alt"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user && !_vm.showRoutes
                      ? _c("headerDisable", {
                          staticClass:
                            "col-md-7 col-7 d-flex align-items-center justify-content-end"
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showNotification
                  ? _c(
                      "div",
                      {
                        staticClass: "notification-blog",
                        attrs: { id: "myDiv" }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-6 col-xl-6 text-right d-flex align-items-center justify-content-end"
                            },
                            [
                              _vm.notifications.length > 0
                                ? _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.readNotification(0, null)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/menu-images/approve-tick.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("MARK ALL AS READ")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.notifications.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "noti_scroll",
                                on: { scroll: _vm.handleScroll }
                              },
                              _vm._l(_vm.notifications, function(
                                notification,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class:
                                      notification.status === "1"
                                        ? "row readNoti"
                                        : "row unreadNoti",
                                    attrs: { data: notification.id },
                                    on: {
                                      click: function($event) {
                                        return _vm.readNotification(
                                          1,
                                          notification
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-11 notification-bulets"
                                      },
                                      [
                                        notification.broadcast_notification
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "notification-title"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      notification
                                                        .broadcast_notification
                                                        .title
                                                    ) +
                                                    "\n                "
                                                ),
                                                notification &&
                                                notification.broadcast_notification &&
                                                notification
                                                  .broadcast_notification
                                                  .external_link !== ""
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            notification
                                                              .broadcast_notification
                                                              .external_link,
                                                          target: "_blank"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.externalLink(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-external-link-alt",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "padding-left":
                                                              "0px"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "noti-date" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getDateFormat(
                                                    notification.notification_date
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "notification-body" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  notification
                                                    .broadcast_notification
                                                    .message_body
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "trash-alt-wrapper" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "white-btn",
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteNotification(
                                                  notification
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("div", { staticClass: "row" }, [_vm._m(5)])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showHeader
        ? _c("div", {}, [
            !_vm.isMobile && _vm.showAppBanner
              ? _c("div", { staticClass: "news-strips" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "news-strips-close",
                      on: {
                        click: function($event) {
                          _vm.showAppBanner = false
                        }
                      }
                    },
                    [_vm._v("×")]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "overly-close",
        on: { click: _vm.toggleRightMenu }
      }),
      _vm._v(" "),
      _c("RouterLink", {
        staticClass: "overly-close",
        attrs: { to: "" },
        nativeOn: {
          click: function($event) {
            return _vm.closeMenu.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        { attrs: { name: "gift", height: "auto", scrollable: false } },
        [
          _c("div", { staticClass: "toast-title" }, [_vm._v("Gifted")]),
          _vm._v(" "),
          _c("div", { staticClass: "toast-message" }, [
            _vm._v(
              "A special Giving Credit of US $100.00 has been added to your account!"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load" }, [
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "loadback" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://b1g1.com/family/home",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("img", {
          staticClass: "d-logo",
          staticStyle: { cursor: "pointer" },
          attrs: {
            src: "/static/front/images/b1g1-logo-black.svg",
            alt: "alt",
            height: "66.45px",
            width: "174px"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://b1g1.com/family/home",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("img", {
          staticClass: "m-logo",
          attrs: {
            src: "/static/front/images/menu-images/b1g1-logo.svg",
            alt: "alt"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "fas fa-caret-down" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/down-arrow.svg",
          alt: "alt"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 col-md-6 col-xl-6" }, [
      _c("h3", { staticStyle: { margin: "0" } }, [_vm._v("Your Notifications")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 readNoti" }, [
      _c("div", { staticClass: "notification-body" }, [
        _vm._v("\n              No messages to display\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Want to create impacts on the go? "),
      _c(
        "a",
        {
          attrs: {
            href: "https://apps.apple.com/us/app/b1g1-family/id6766782184",
            target: "_blank"
          }
        },
        [_c("strong", [_vm._v("Install iOS App")])]
      ),
      _vm._v(" or "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=com.b1g1family.app",
            target: "_blank"
          }
        },
        [_c("strong", [_vm._v("Android App")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7a22808", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a22808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/Header.vue
// module id = null
// module chunks = 